<template>
    <div>

 

        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <p class="is-size-5"> Status  </p>

                </div>
                <div class="level-item">
                    <p v-if="dataCytoSpecLN.status.id < 5 "  class="is-size-5 has-text-info"> &nbsp; {{ dataCytoSpecLN.status.name }}  </p>
                    <p v-if="dataCytoSpecLN.status.id >=5 && dataCytoSpecLN.status.id <=6"  class="is-size-5 has-text-success"> &nbsp; {{ dataCytoSpecLN.status.name }}  </p>
                    <p v-if="dataCytoSpecLN.status.id === 7 "  class="is-size-5 has-text-danger"> &nbsp; {{ dataCytoSpecLN.status.name }} </p>
                </div>
                <div class="level-item">
                    <b-icon icon="lock" type="is-danger"  v-if="dataCytoSpecLN.status.id >=5 "  ></b-icon>
                    <b-icon icon="lock-open" type="is-success"  v-if="dataCytoSpecLN.status.id < 5 "  ></b-icon>
                </div>
                <div class="level-item">
                    <p class="is-size-5"> Assigned for </p>
                </div>
                <div class="level-item">
                    <p class="is-size-5 has-text-grey"> &nbsp; {{ dataCytoSpecLN.assigned_to_user.name }}</p>
                </div>
                <div class="level-item">

                    <b-button type="is-success"
                              id="button_edit"
                              icon-left="pencil"
                              @click="showEditDocLABTxtKind"
                              ref="btnEditLNNonautomate"
                              :disabled="!IDLABSelected.idlab "
                              v-if="
                                (
                                 (  ( dataCytoSpecLN && (userRoleFind(3) || userRoleFind(4)  ))     )
                                 ||
                                    ( dataCytoSpecLN && userIsAdmin )
                                 ||
                                  ( dataCytoSpecLN && dataCytoSpecLN.assigned_to_user.id === user_id )
                                 )  && dataCytoSpecLN.status.id <=5

                                 ">
                        Edit
                    </b-button>

                </div>
                <div class="level-item" v-if="dataCytoSpecLN.status.id >=5 && userRoleFind(6)">
                    <b-dropdown aria-role="menu" position="is-bottom-left" :disabled="loadingReportFile || loadingImgReportFile || isSelectImgForMakePdf">
                        <template #trigger>
                            <b-button type="is-primary is-light" icon-left="file-pdf-box" icon-right="chevron-down"
                                      :loading="loadingReportFile" :disabled="loadingReportFile || loadingImgReportFile || isSelectImgForMakePdf" aria-haspopup="menu">
                                View as Pdf(Text)
                            </b-button>
                        </template>
                        <b-dropdown-item aria-role="menuitem" @click="selectReportMethod('legacy', false)">PDF แบบเดิม</b-dropdown-item>
                        <b-dropdown-item aria-role="menuitem" :disabled="dataCytoSpecLN.status.id > 6"
                                         @click="selectReportMethod('reportlab', false)">PDF ReportLab</b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="level-item" v-if="dataCytoSpecLN.status.id >=5 && userRoleFind(6)">
                    <b-dropdown aria-role="menu" position="is-bottom-left" :disabled="loadingReportFile || loadingImgReportFile || isSelectImgForMakePdf || !dataCytoSpecLN.display_title_image_for_nonadmin">
                        <template #trigger>
                            <b-button type="is-primary is-light" icon-left="file-pdf-box" icon-right="chevron-down"
                                      :loading="loadingImgReportFile" :disabled="loadingReportFile || loadingImgReportFile || isSelectImgForMakePdf || !dataCytoSpecLN.display_title_image_for_nonadmin" aria-haspopup="menu">
                                View as Pdf(Images)
                            </b-button>
                        </template>
                        <b-dropdown-item aria-role="menuitem" @click="selectReportMethod('legacy', true)">PDF แบบเดิม</b-dropdown-item>
                        <b-dropdown-item aria-role="menuitem" :disabled="dataCytoSpecLN.status.id > 6"
                                         @click="selectReportMethod('reportlab', true)">PDF ReportLab</b-dropdown-item>
                    </b-dropdown>
                </div>


            </div>
            <div class="level-right" v-if="( (dataCytoSpecLN.assigned_to_user.id === user_id )||(userIsAdmin) )&& ( dataCytoSpecLN.status.id >= 5 &&dataCytoSpecLN.status.id <= 6)">
                <div class="level-item">
                    <b-button type="is-danger"
                              icon-left="plus"
                              class="btn_plus"
                              @click="plusSomething">Plus
                    </b-button>
                </div>
                <div class="level-item">
                    <b-field
                            :type="{ 'is-danger': hasErrorPlusSomethingSelected}"
                            :message="{ 'pls select  ': hasErrorPlusSomethingSelected}">
                        <b-select placeholder="Select Plus Type" v-model="plusSomethingSelected">
                            <option value = 0> {{headerInfoPrepare}} </option>
                            <option value = 1> {{findingAndContent}} </option>
                            <option value = 2> {{images_title}} </option>
                            <option value = 3> {{ClassificationOfDiseases}} </option>
                        </b-select>
                    </b-field>
                </div>
            </div>
        </nav>
        <hr>





        <div v-if="dataCytoSpecLN && dataCytoSpecLN.status.id >= 5 && dataCytoSpecLN.status.id <=6 ">





 <!-- Display Title if normal or plus existing  -->
<!--          <div v-if="dataCytoSpecLN.dat_prepare.dat_txt.length>0 || dataCytoSpecLN && dataCytoSpecLN.data_plus.dat_prepare.length>0 ">-->
<!--              <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                         :titleDisplay="headerPrepareInfo"-->
<!--                         :plus=false-->
<!--                         :showIcon = true-->
<!--                         :showDatUserWhoView = "false"-->
<!--                         :showTitleDisplay = true-->
<!--                         :iconToShow = "iconFileDocument"-->
<!--                         :visible = "true"/>-->
<!--          </div>-->

            <div v-if="displayTitle(dataCytoSpecLN.dat_prepare.dat,dataCytoSpecLN.data_plus.dat_prepare,dataCytoSpecLN.display_title_prepare_for_nonadmin) ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="headerPrepareInfo"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconFileDocument"
                           :visible = "true"/>
            </div>

 <!----------------------  Prepared   disPlayOrNot   dataCytoSpecLN && dataCytoSpecLN.dat_prepare.dat_txt.length>0  ------>
          <div class="container"  v-if="disPlayOrNot(dataCytoSpecLN ,dataCytoSpecLN.dat_prepare.dat_txt.length ,dataCytoSpecLN.dat_prepare.visible )" >
                   <TitlePlus :datUserWhoView="getNameAndSurname"
                              :titleDisplay="headerPrepareInfo"
                              :plus=false
                              :showIcon = false
                              :showTitleDisplay = false
                              :visible = " dataCytoSpecLN.dat_prepare.visible "/>
                <div class="box"  >
                   <div  v-html="getDecodeFromBase64ToHtml( dataCytoSpecLN.dat_prepare.dat )"
                        :style= "getStyleVisibleFalseInContent(dataCytoSpecLN.dat_prepare.visible)" >
                   </div>
                </div>
                   <FooterPlus  :user_rec="dataCytoSpecLN.dat_prepare.user_rec"
                                :date_rec="dataCytoSpecLN.dat_prepare.date_rec"
                                :time_rec="dataCytoSpecLN.dat_prepare.time_rec"
                                :user_delete="dataCytoSpecLN.dat_prepare.user_edit"
                                :date_delete="dataCytoSpecLN.dat_prepare.date_edit"
                                :time_delete="dataCytoSpecLN.dat_prepare.time_edit"
                                :userIsAdmin="userIsAdmin"
                                :idToDelete = "dataCytoSpecLN.dat_prepare.id.toString()"
                                :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare"
                                :labKind = "IDLABSelected.kind"
                                :canDelete ="dataCytoSpecLN.dat_prepare.visible"
                                @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
               </div>
<!----------------------- Prepare Plus  dataCytoSpecLN && dataCytoSpecLN.data_plus.dat_prepare.length>0 -->
          <div v-for="dat_prepare_plus in  dataCytoSpecLN.data_plus.dat_prepare" :key="dat_prepare_plus.id">
                    <div  class="container" v-if="disPlayOrNot(true,true,dat_prepare_plus.visible)">
                             <TitlePlus :datUserWhoView="getNameAndSurname"
                                        :titleDisplay="headerPrepareInfoPlus"
                                        :plus=true
                                        :showIcon = false
                                        :showTitleDisplay = false
                                        :visible = " dat_prepare_plus.visible "
                             />
                            <div class="box"  >
                                <div v-html="getDecodeFromBase64ToHtml(dat_prepare_plus.dat)"  :style= "getStyleVisibleFalseInContent(dat_prepare_plus.visible)"
                                     >
                                </div>
                            </div>
                             <FooterPlus  :user_rec="dat_prepare_plus.user_rec"
                                          :date_rec="dat_prepare_plus.date_rec"
                                          :time_rec="dat_prepare_plus.time_rec"
                                          :user_delete="dat_prepare_plus.user_edit"
                                          :date_delete="dat_prepare_plus.date_edit"
                                          :time_delete="dat_prepare_plus.time_edit"
                                          :canDelete ="dat_prepare_plus.visible"
                                          :userIsAdmin="userIsAdmin"
                                          :idToDelete = "dat_prepare_plus.id.toString()"
                                          :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare_plus"
                                          :labKind = "IDLABSelected.kind"
                                          @footerPlusWithChangeDisable="footerPlusWithChangeDisable"
                                           />
                    </div>
                 </div>






<!-- Display Title if normal or plus existing  -->
<!--            <div class="container" v-if="dataCytoSpecLN.display_title_ct_for_nonadmin ">-->
<!--            <div v-if="dataCytoSpecLN.dat_ct.dat_txt.length>0 || dataCytoSpecLN && dataCytoSpecLN.data_plus.dat_ct.length>0 ">-->

<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="findingAndContent"-->
<!--                               :plus=false-->
<!--                               :showIcon = true-->
<!--                               :showDatUserWhoView = "false"-->
<!--                               :showTitleDisplay = true-->
<!--                               :iconToShow = "iconFileDocument"-->
<!--                               :visible = "true"/>-->
<!--            </div>-->

            <div v-if="displayTitle(dataCytoSpecLN.dat_ct.dat,dataCytoSpecLN.data_plus.dat_ct,dataCytoSpecLN.display_title_ct_for_nonadmin)">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="findingAndContent"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconFileDocument"
                           :visible = "true"/>
            </div>


<!----------------------  Content  ------>
            <div class="container"  v-if="disPlayOrNot(dataCytoSpecLN ,dataCytoSpecLN.dat_ct.dat_txt.length ,dataCytoSpecLN.dat_ct.visible )" >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="findingAndContent"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataCytoSpecLN.dat_ct.visible "/>
                <div class="box"  >
                    <div v-html="getDecodeFromBase64ToHtml( dataCytoSpecLN.dat_ct.dat )"  :style= "getStyleVisibleFalseInContent(dataCytoSpecLN.dat_ct.visible)"></div>
                </div>
                <FooterPlus  :user_rec="dataCytoSpecLN.dat_ct.user_rec"
                             :date_rec="dataCytoSpecLN.dat_ct.date_rec"
                             :time_rec="dataCytoSpecLN.dat_ct.time_rec"
                             :user_delete="dataCytoSpecLN.dat_ct.user_edit"
                             :date_delete="dataCytoSpecLN.dat_ct.date_edit"
                             :time_delete="dataCytoSpecLN.dat_ct.time_edit"
                             :canDelete ="dataCytoSpecLN.dat_ct.visible"
                             :userIsAdmin="userIsAdmin"
                             :idToDelete = "dataCytoSpecLN.dat_ct.id.toString()"
                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct"
                             :labKind = "IDLABSelected.kind"
                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
            </div>
<!--           Content Plus  -->
            <template  v-for="dat_content_plus in  dataCytoSpecLN.data_plus.dat_ct" >
                <span :key="dat_content_plus.id">
                        <div  class="container" v-if="disPlayOrNot(true,true,dat_content_plus.visible)">
                            <TitlePlus :datUserWhoView="getNameAndSurname"
                                       :titleDisplay="findingAndContentPlus"
                                       :plus=true
                                       :showIcon = false
                                       :showTitleDisplay = false
                                       :visible = " dat_content_plus.visible "/>
                            <div class="box"  >
                                <div v-html="getDecodeFromBase64ToHtml(dat_content_plus.dat)" :style= "getStyleVisibleFalseInContent(dat_content_plus.visible)"></div>
                            </div>
                            <FooterPlus  :user_rec="dat_content_plus.user_rec"
                                         :date_rec="dat_content_plus.date_rec"
                                         :time_rec="dat_content_plus.time_rec"
                                         :user_delete="dat_content_plus.user_edit"
                                         :date_delete="dat_content_plus.date_edit"
                                         :time_delete="dat_content_plus.time_edit"
                                         :canDelete ="dat_content_plus.visible"
                                         :userIsAdmin="userIsAdmin"
                                         :idToDelete = "dat_content_plus.id.toString()"
                                         :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct_plus"
                                         :labKind = "IDLABSelected.kind"
                                         @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                        </div>
               </span>
            </template>

<!--            <div   class="container"   v-for="dat_content_plus in  dataCytoSpecLN.data_plus.dat_ct" :key="dat_content_plus.id" >-->
<!--                  <template   v-if="disPlayOrNot(true,true,dat_content_plus.visible)">-->
<!--                      {{dat_content_plus}}-->
<!--                        <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                                   :titleDisplay="findingAndContentPlus"-->
<!--                                   :plus=true-->
<!--                                   :showIcon = false-->
<!--                                   :showTitleDisplay = false-->
<!--                                   :visible = " dat_content_plus.visible "/>-->
<!--                        <div class="box"  >-->
<!--                            <div v-html="getDecodeFromBase64ToHtml(dat_content_plus.dat)" :style= "getStyleVisibleFalseInContent(dat_content_plus.visible)"></div>-->
<!--                        </div>-->
<!--                        <FooterPlus  :user_rec="dat_content_plus.user_rec"-->
<!--                                     :date_rec="dat_content_plus.date_rec"-->
<!--                                     :time_rec="dat_content_plus.time_rec"-->
<!--                                     :user_delete="dat_content_plus.user_edit"-->
<!--                                     :date_delete="dat_content_plus.date_edit"-->
<!--                                     :time_delete="dat_content_plus.time_edit"-->
<!--                                     :canDelete ="dat_content_plus.visible"-->
<!--                                     :userIsAdmin="userIsAdmin"-->
<!--                                     :idToDelete = "dat_content_plus.id.toString()"-->
<!--                                     :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct_plus"-->
<!--                                     :labKind = "IDLABSelected.kind"-->
<!--                                     @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--                  </template>-->
<!--                </div>-->









<!-- Display Title if normal or plus existing  -->
<!--            <div v-if="  dataCytoSpecLN.img.dat.length>0 ||   dataCytoSpecLN.data_plus.img.length>0 ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="images_title"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconImage"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->

            <div v-if="displayTitle(dataCytoSpecLN.img.dat, dataCytoSpecLN.data_plus.img , dataCytoSpecLN.display_title_image_for_nonadmin) ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="images_title"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconImage"
                           :visible = "true"/>
            </div>

<!----------------------  Images  ------>
            <template v-if="disPlayOrNot(dataCytoSpecLN ,dataCytoSpecLN.img.dat.length ,
                                         dataCytoSpecLN.img.dat.length>0 ? dataCytoSpecLN.img.dat[0].visible : false  )">
                <div class="container"  v-if="dataCytoSpecLN && dataCytoSpecLN.img.dat.length>0 " >
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="images_title"
                               :plus=false
                               :showDatUserWhoView = true
                               :showIcon = false
                               :showTitleDisplay = false
                                 />



                    <ThumbnailImageList  v-if="dataPassThruImageList.length>0"
                                         :modeThumbnailImageList="modeThumbnailImageList"
                                         :dataPassThruImageList="dataPassThruImageList"
                                         :plus="false"/>


                    <FooterPlus  :user_rec="dataCytoSpecLN.img.user_rec"
                                 :date_rec="dataCytoSpecLN.img.date_rec"
                                 :time_rec="dataCytoSpecLN.img.time_rec"
                                 :user_delete="dataCytoSpecLN.img.user_edit"
                                 :date_delete="dataCytoSpecLN.img.date_edit"
                                 :time_delete="dataCytoSpecLN.img.time_edit"
                                 :canDelete ="dataCytoSpecLN.img.user_edit.length>0 ? false : true"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "IDLABSelected.idlab"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                </div>

            </template>
<!----------------------   Image Plus  ------>
                    <div  class="container"  v-for=" img in dataCytoSpecLN.data_plus.img" :key="img.idtime">
                        <template v-if="disPlayOrNot(true,true,img.visible[0])">
                            <TitlePlus :datUserWhoView="getNameAndSurname"
                                       :titleDisplay="ImagePlus"
                                       :plus=true
                                       :showIcon = false
                                       :showTitleDisplay = false
                                       :showDatUserWhoView = true
                            />
                            <br>
                            <ThumbnailImageList    :modeThumbnailImageList="modeThumbnailImageList"
                             :dataPassThruImageList="dataPassThruImageListPlus(img.idtime)"  
                             :plus="true"  />
                            <FooterPlus  :user_rec="getUserRecImgPlusByIdTime(img.idtime)"
                                         :date_rec="getDateRecImgPlusByIdTime(img.idtime)"
                                         :time_rec="getTimeRecImgPlusByIdTime(img.idtime)"
                                         :user_delete="img.user_edit.length>0 ? img.user_edit[0] : '' "
                                         :date_delete="img.date_edit.length>0 ? img.date_edit[0] : '' "
                                         :time_delete="img.time_edit.length>0 ? img.time_edit[0] : ''"
                                         :canDelete ="img.visible.length>0 ? img.visible[0] : false"
                                         :userIsAdmin="userIsAdmin"
                                         :idToDelete = "img.idtime.toString()"
                                         :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images_plus"
                                         :labKind = "IDLABSelected.kind"
                                         @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                            <br>
                        </template>
                    </div>







<!---------------- Display Title if normal or plus existing  -->
<!--                <div v-if="  dataCytoSpecLN.diag_code.dat.length>0 ||   dataCytoSpecLN.data_plus.diag_code.length>0 ">-->
<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="ClassificationOfDiseases"-->
<!--                               :plus=false-->
<!--                               :showIcon = true-->
<!--                               :showDatUserWhoView = "false"-->
<!--                               :showTitleDisplay = true-->
<!--                               :iconToShow = "iconDx"-->
<!--                               :visible = "true"/>-->
<!--                </div>-->


            <div v-if="displayTitle(dataCytoSpecLN.diag_code.dat , dataCytoSpecLN.data_plus.diag_code , dataCytoSpecLN.display_title_diag_for_nonadmin)">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="ClassificationOfDiseases"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconDx"
                           :visible = "true"/>
            </div>

<!----------------------  Diagosis  ------>
            <template v-if="disPlayOrNot(dataCytoSpecLN ,dataCytoSpecLN.diag_code.dat.length ,
                                         dataCytoSpecLN.diag_code.dat.length>0 ? dataCytoSpecLN.diag_code.dat[0].visible : false  )">
                <div class="container"  v-if="dataCytoSpecLN && dataCytoSpecLN.diag_code.dat.length>0" >
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="ClassificationOfDiseases"
                               :plus=false
                               :showIcon = false
                               :showDatUserWhoView = "true"
                               :showTitleDisplay = false
                       />
                    <b-table             :data="isEmpty ? [] : dataCytoSpecLN.diag_code.dat "
                                         bordered
                                         striped
                                         narrowed
                                         hoverable
                                         focusable
                                         mobile-cards
                                         >


                                        <b-table-column field="level1Name" label="Chapter" v-slot="props">
                                            {{ props.row.level1Name }}
                                        </b-table-column>

                                        <b-table-column field="level2Name" label="Body System" v-slot="props">
                                            {{ props.row.level2Name }}
                                        </b-table-column>

                                        <b-table-column field="level3Name" label="Organ/Tissue" v-slot="props">
                                            {{ props.row.level3Name }}
                                        </b-table-column>

                                        <b-table-column field="level4Name" label="Character/Subcategories" v-slot="props">
                                            {{ props.row.level4Name }}
                                        </b-table-column>

                                        <b-table-column field="level5Name" label="Extensions" v-slot="props">
                                            {{ props.row.level5Name }}
                                        </b-table-column>


                                        <b-table-column field="level5Name" label="Unclassified Descriptions" v-slot="props">
                                            {{ props.row.unClassifiedCodes }}
                                        </b-table-column>


                                        <b-table-column field="level5Name" label="%" v-slot="props">
                                            {{ props.row.labDiseasecodeAccurateName }}
                                        </b-table-column>


                                        <b-table-column field="level5Name" label="Comment"  v-slot="props">
                                            {{ props.row.comment }}
                                        </b-table-column>

                                </b-table>
                    <FooterPlus  :user_rec="dataCytoSpecLN.diag_code.user_rec"
                                 :date_rec="dataCytoSpecLN.diag_code.date_rec"
                                 :time_rec="dataCytoSpecLN.diag_code.time_rec"

                                 :user_delete="dataCytoSpecLN.diag_code.user_edit"
                                 :date_delete="dataCytoSpecLN.diag_code.date_edit"
                                 :time_delete="dataCytoSpecLN.diag_code.time_edit"
                                 :canDelete ="dataCytoSpecLN.diag_code.user_edit.length>0 ? false : true"

                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "IDLABSelected.idlab"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>
                    <br>
                </div>

            </template>

<!----------------------         Diagosis Plus   dataCytoSpecLN.data_plus.diag_code  v-if="dataCytoSpecLN.data_plus.diag_code.length>0"-->

            <div  class="container"  v-for=" diag_code_plus in dataCytoSpecLN.data_plus.diag_code" :key="diag_code_plus.idtime">
                <template v-if="disPlayOrNot(true,true,diag_code_plus.visible)">



                <TitlePlus
                        :datUserWhoView="getNameAndSurname"
                        :titleDisplay="ClassificationOfDiseases"
                        :plus=true
                        :showIcon = false
                        :showTitleDisplay = false
                        :showDatUserWhoView = true
                />
                <b-table         :data="diag_code_plus.dat"
                                 bordered
                                 striped
                                 narrowed
                                 hoverable
                                 focusable
                                 mobile-cards
                >
                    <b-table-column   label="Chapter" v-slot="props">
                        {{ props.row.level1Name }}
                    </b-table-column>
                    <b-table-column   label="Body System" v-slot="props">
                        {{ props.row.level2Name }}
                    </b-table-column>
                    <b-table-column   label="Organ/Tissue" v-slot="props">
                        {{ props.row.level3Name }}
                    </b-table-column>
                    <b-table-column   label="Character/Subcategories" v-slot="props">
                        {{ props.row.level4Name }}
                    </b-table-column>
                    <b-table-column   label="Extensions" v-slot="props">
                        {{ props.row.level5Name }}
                    </b-table-column>
                    <b-table-column  label="Unclassified Descriptions" v-slot="props">
                        {{ props.row.unClassifiedCodes }}
                    </b-table-column>
                    <b-table-column  label="%" v-slot="props">
                        {{ props.row.labDiseasecodeAccurateName }}
                    </b-table-column>
                    <b-table-column  label="Remark" v-slot="props">
                        {{ props.row.comment }}
                    </b-table-column>

                </b-table>
                <FooterPlus  :user_rec="diag_code_plus.dat[0].user_rec"
                             :date_rec="diag_code_plus.dat[0].date_rec"
                             :time_rec="diag_code_plus.dat[0].time_rec"
                             :user_delete="diag_code_plus.dat[0].user_edit.length>0 ? diag_code_plus.dat[0].user_edit : '' "
                             :date_delete="diag_code_plus.dat[0].date_edit.length>0 ? diag_code_plus.dat[0].date_edit : '' "
                             :time_delete="diag_code_plus.dat[0].time_edit.length>0 ? diag_code_plus.dat[0].time_edit : '' "
                             :canDelete ="diag_code_plus.visible"
                             :userIsAdmin="userIsAdmin"
                             :idToDelete = "diag_code_plus.idtime.toString()"
                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code_plus"
                             :labKind = "IDLABSelected.kind"
                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />

                </template>
            </div>


<!---------------- Display Title if normal or plus existing  -->
            <div   class="container"   v-if="  dataCytoSpecLN ">
              
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="RequestedInfo"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconInfoRequest"
                           :visible = "true"/>
            </div>
<!-----------------     Request Info.  ----------------->
            <div class="container"  v-if="dataCytoSpecLN" >
                 
                    <TitlePlus
                            :datUserWhoView="getNameAndSurname"
                            :titleDisplay="RequestedInfo"
                            :plus=false
                            :showIcon = false
                            :showTitleDisplay = false
                            :showDatUserWhoView = true
                    />
                    
                    <FooterRequest :dataReqToFooter="dataCytoSpecLN.data_req"/>
             </div>
        </div>








        <EditDocLABTxtKind ref="EditDocLABTxtKind"
                   :IDLABSelected="IDLABSelected"
                   @close="closeEditDocLAB"
                   />
        <PlusEditor   v-if="isPlusEditor"
                      :isShowing="isPlusEditor"
                      :idlab="IDLABSelected.idlab"
                      :labKind="IDLABSelected.kind"
                      :submitTypePlusEdit="submitTypePlusEditTmp"
                      @close="closePlusEditor"
                      @closeWithChange="closePlusEditorWithChange" />
        <PlusImages  v-if="isPlusImages"
                     :isShowing="isPlusImages"
                     :idlab="IDLABSelected.idlab"
                     @closePlusImagesWithData="closePlusImagesWithData"
                     @closePlusImages="closePlusImages"/>

        <PlusSelectDiseaseCode v-if="isPlusSelectDiseaseCode"
                      :idlab="IDLABSelected.idlab"
                      :isShowing="isPlusSelectDiseaseCode"
                      @closePlusSelectDiseaseCode_WithChange = "closePlusSelectDiseaseCode_WithChange"
                      @closePlusSelectDiseaseCode="closePlusSelectDiseaseCode"/>


        <b-modal
                v-model="isSelectImgForMakePdf"
                has-modal-card
                full-screen
                :can-cancel="true">
            <SelectImgForMakePdf
                    :arrImg = "arrPropsToImgReport"
                    @closeSelectImgForMakePdfWithDataWantTo="doReqImageReportFile"
                    @closeSelectImgForMakePdf="closeSelectImgForMakePdf"/>
        </b-modal>

    </div>





 
</template>

<script>

    import globalconst from "../../mixins/globalconst";
    import userRoleFind from "../../mixins/methods/userRoleFind";
    import {mapActions, mapState} from "vuex";

    import { genUUID, getBaseURLAvartar , DATACYTOSPECLN_MODEL  } from '@/utils.js'
    import EditDocLABTxtKind from "./EditDocLABTxtKind";
    import ThumbnailImageList from "../UtilsComponents/ThumbnailImageList";
    import FooterRequest from "./FooterRequest";
    import TitlePlus from "./Plus/TitlePlus";
    import FooterPlus from "./Plus/FooterPlus";
    import PlusEditor from "./Plus/PlusEditor";
    import PlusSelectDiseaseCode from "./Plus/PlusSelectDiseaseCode";
    import PlusImages from "./Plus/PlusImages";
    import changeStatusFromIncompleteToComplete from "../../mixins/methods/changeStatusFromIncompleteToComplete";
    import getStyleVisibleFalseInContent from "../../mixins/methods/getStyleVisibleFalseInContent";
    import iconTitle from "../../mixins/data/iconTitle";
    import getDecodeFromBase64ToHtml from "../../mixins/methods/getDecodeFromBase64ToHtml";
    import disPlayOrNot from "../../mixins/methods/disPlayOrNot";
    import doCytologyReportLab from "../../mixins/methods/doCytologyReportLab";
    import doReportFile from "../../mixins/methods/doReportFile";
    import selectURL_NextFrom_DoReportFile_ByCallFrmVar from "../../mixins/methods/selectURL_NextFrom_DoReportFile_ByCallFrmVar";  
    import displayTitle from "../../mixins/methods/displayTitle";
    import FileSaver from "file-saver";


    import SelectImgForMakePdf from "./SelectImgForMakePdf/SelectImgForMakePdf";

    export default {
        name: "Cytology_EachID",
        components:{
             EditDocLABTxtKind,
             ThumbnailImageList,
             FooterRequest,
             TitlePlus,
             FooterPlus,

             PlusEditor,
             PlusImages ,
             PlusSelectDiseaseCode,

             SelectImgForMakePdf
        },
        props:{
            dataCytoSpecLN : DATACYTOSPECLN_MODEL ,
            IDLABSelected: null ,
            isCytoShowing:{
                type : Boolean,
                default : false
            }
        },
        mixins:[globalconst,userRoleFind,changeStatusFromIncompleteToComplete,getStyleVisibleFalseInContent,
                iconTitle,getDecodeFromBase64ToHtml,disPlayOrNot,doReportFile,doCytologyReportLab, selectURL_NextFrom_DoReportFile_ByCallFrmVar ,displayTitle],
        methods:{

            ...mapActions({
                fetchMyJobsTray: 'myjobstray/fetchMyJobsTray',
            }),







            closeSelectImgForMakePdf(){
                this.isSelectImgForMakePdf = false
            },

            selectReportMethod(engine, images) {
                if (this.loadingReportFile || this.loadingImgReportFile || this.isSelectImgForMakePdf) return
                if (engine === 'reportlab' && this.dataCytoSpecLN.status.id > 6) return
                this.reportEngine = engine
                if (images) this.reqImageReportFile()
                else this.reqReportFile(false, -1, [])
            },

            reqImageReportFile(){
                if  (this.dataCytoSpecLN.display_title_image_for_nonadmin){
                    // build arr
                    // {"id":1  , "descp": "lorem","select": true,"url": "http://127.0.0.1:5000/static/uploads/64BIOP0000000155/179452040286.jpg"}
                    // `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                    this.arrPropsToImgReport = []
                    //genUUID
                    this.dataCytoSpecLN.img.dat.forEach(dat=>{
                        if (dat.visible){
                            this.arrPropsToImgReport.push(   {"id":genUUID(5)  , "descp": "", "select": false,"url": `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}` , "file": dat.file }  )
                        }
                    })
                    //
                    for(var i =0 ; i<this.dataCytoSpecLN.data_plus.img.length;i++){
                        for(var j =0; j < this.dataCytoSpecLN.data_plus.img[i].visible.length ; j++){
                            if (this.dataCytoSpecLN.data_plus.img[i].visible[j]){
                                this.arrPropsToImgReport.push(
                                    {"id":genUUID(5)  , "descp": "", "select": false,
                                        "url": `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${this.dataCytoSpecLN.data_plus.img[i].file[j]}` ,
                                        "file": this.dataCytoSpecLN.data_plus.img[i].file[j]
                                    }
                                )
                            }
                        }

                    }


                    if ( this.arrPropsToImgReport.length >0 ){
                        this.isSelectImgForMakePdf = true
                    }else{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Nothing Images`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    }



                }

            },


            doReqImageReportFile(payload){
                this.isSelectImgForMakePdf = false
                var arr_img_data_want = []
                for(var i=0;i<payload.arrImg.length;i++){
                    if (payload.arrImg[i].select){
                        arr_img_data_want.push(payload.arrImg[i].file)
                    }
                }

                this.reqReportFile(true,parseInt( payload.num_of_col ) ,arr_img_data_want)


            },

            reqReportFile(pure_Img,col_if_pure_img,arr_img_data_want){
                let previewWindow = null
                if (this.reportEngine === 'reportlab') {
                    previewWindow = window.open('', '_blank')
                    if (!previewWindow) {
                        this.$buefy.dialog.alert({title: 'PDF Preview', message: 'กรุณาอนุญาต popup สำหรับเว็บไซต์นี้ แล้วลองอีกครั้ง', type: 'is-warning'})
                        return
                    }
                    previewWindow.opener = null
                    previewWindow.document.title = 'PDF Preview'
                    previewWindow.document.body.textContent = 'กำลังสร้าง PDF…'
                }
                if(pure_Img){
                    this.loadingImgReportFile = true
                    }else{
                    this.loadingReportFile = true
                }

                const useReportLab = this.reportEngine === 'reportlab'
                const report = useReportLab
                    ? this.doCytologyReportLab(pure_Img,col_if_pure_img,arr_img_data_want)
                    : this.doReportFile(this.IDLABSelected,this.clientIP,pure_Img,col_if_pure_img,arr_img_data_want)
                report.then(res=>{
                         if (useReportLab) {
                             if (previewWindow.closed) return
                             const blobUrl = URL.createObjectURL(res)
                             try {
                                 previewWindow.location.replace(blobUrl)
                             } catch (error) {
                                 URL.revokeObjectURL(blobUrl)
                                 throw error
                             }
                             // Keep the URL valid for the viewer's print/download actions.
                             const cleanup = window.setInterval(() => {
                                 if (previewWindow.closed) {
                                     URL.revokeObjectURL(blobUrl)
                                     window.clearInterval(cleanup)
                                 }
                             }, 1000)
                         }
                         else FileSaver.saveAs(this.selectURL_NextFrom_DoReportFile_ByCallFrmVar(res), `${res.file_name}.pdf`);
                         if(pure_Img){
                             this.loadingImgReportFile = false
                         }else{
                             this.loadingReportFile = false
                         }
                     })
                    .catch(err=>{
                        if (previewWindow && !previewWindow.closed) previewWindow.close()
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: String((err.response && err.response.data && err.response.data.msg) || err.message || 'ไม่สามารถสร้าง PDF ได้').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch])),
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
                    .finally(()=>{
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
            },








            //*****************************************
            //*****************************************
            //*****************************************
            // Plus
            plusSomething(){
                // showPlusEditor(SUBMIT_TYPE_PLUS_EDIT.prepare)
                if(this.plusSomethingSelected === null){
                   this.hasErrorPlusSomethingSelected = true
                   return
                }


                if(this.plusSomethingSelected  == 0){
                    this.showPlusEditor(this.SUBMIT_TYPE_PLUS_EDIT.prepare)
                }else if (this.plusSomethingSelected  == 1){
                    this.showPlusEditor(this.SUBMIT_TYPE_PLUS_EDIT.ct)
                }else if (this.plusSomethingSelected  == 2){
                    this.showPlusImages()
                }else if (this.plusSomethingSelected  == 3){
                    this.addPlusSelectDiseaseCode()
                }else {
                    return
                }
            },

            closePlusSelectDiseaseCode_WithChange(){
                // console.log(data)
                //   //level5ID

                this.$emit('trigForPlusUpdate')
                this.isPlusSelectDiseaseCode = false
            },
            closePlusSelectDiseaseCode(){
                this.isPlusSelectDiseaseCode = false
            },
            closePlusEditorWithChange(){
                this.$emit('trigForPlusUpdate')
                this.isPlusEditor = false
            },
            closePlusEditor(){
                this.isPlusEditor = false
            },
            showPlusEditor(_type){
                this.submitTypePlusEditTmp = _type
                this.isPlusEditor = true
            },
            closePlusImagesWithData(){
                this.isPlusImages = false
                this.$emit('trigForPlusUpdate')
            },
            closePlusImages(){
                this.isPlusImages = false
            },
            showPlusImages(){
                this.isPlusImages = true
            },
            addPlusSelectDiseaseCode(){
                this.isPlusSelectDiseaseCode = true
            },

            footerPlusWithChangeDisable(){
                this.$emit('trigForPlusUpdate')
            },



            //*****************************************
            //*****************************************
            //*****************************************
            // Normal for this component
            getTimeRecImgPlusByIdTime(_idtime){
                const member  = this.dataCytoSpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.time_rec[0]
            },
            getDateRecImgPlusByIdTime(_idtime){
                const member  = this.dataCytoSpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.date_rec[0]
            },
            getUserRecImgPlusByIdTime(_idtime){
                const member  = this.dataCytoSpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.user_rec[0]
            },
            dataPassThruImageListPlus(_idtime) {
                if(this.dataCytoSpecLN.data_plus.img.length>0) {
                    const member = this.dataCytoSpecLN.data_plus.img.find(data => data.idtime === _idtime)
                    var tmpArr = []
                    for (var i = 0; i <= member.id.length - 1; i++) {
                        const tmp = {
                            id: member.id[i],
                            file: null,
                            urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${member.file[i]}`,
                            title: member.title[i],
                            fileNameUploaded: member.file[i],
                            fresh: false
                        }
                        tmpArr.push(tmp)
                    }
                    return tmpArr
                }else{
                    return []
                }
            },
            // dataAvartar(iduser,avatar){
            //     return  `${getBaseURLAvartar()}/user_${iduser}/${avatar}`
            // },
            closeEditDocLAB(){
                this.$emit('close')
            },
            showEditDocLABTxtKind(){
                this.$refs.EditDocLABTxtKind.loadData()
                this.$refs.EditDocLABTxtKind.getMyTemplateLocal()
                this.$refs.EditDocLABTxtKind.isComponentModalActive = true
                // this.$refs.EditDocLABTxtKind.dataTemplateSelected = null
            }
        },
        computed: {
            ...mapState({
                user_id: state => state.master_data.user_id,
                user_role :  state => state.master_data.user_role,
                userIsAdmin:  state => state.master_data.userIsAdmin,
                OPDSelected : state => state.opd_target.opd_selected,
                clientIP: state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            }),


            getNameAndSurname: function(){
                // return 'test'
               const userFullName = localStorage.getItem('user_name_surname')
                return  `<p class="has-text-weight-light has-text-grey-lighter" style="color: #00b89c; padding-top: 15px"> View by ${userFullName}
                          ${this.dataCytoSpecLN.current_date}
                          ${this.dataCytoSpecLN.current_time} </p>`
                // return localStorage.getItem('user_name_surname')
            },


           dataPassThruImageList: function () {
                    // [ { id: tmpID ,
                    //     file : null,
                    //     urlTempUploaded: tmpUrl,
                    //     title : vm.dataAllContent.img.dat[i].title,
                    //     fileNameUploaded:  vm.dataAllContent.img.dat[i].file ,
                    //     fresh : false  } ]
               if(this.dataCytoSpecLN.img.dat.length>0) {
                   return this.dataCytoSpecLN.img.dat.map(dat => {
                       return {
                           id: genUUID(5),
                           file: null,
                           urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                           title: dat.title,
                           fileNameUploaded: dat.file,
                           fresh: false
                       }
                   })
               }else{
                   return []
               }
         }
        },
        data(){
            return {
                isEmpty: false,
                activeStep: 0,
                navigation: false,
                modeThumbnailImageList: "view",

                // Plus
                submitTypePlusEditTmp: "",
                isPlusEditor: false,
                isModalUploadFiles: false,
                isPlusSelectDiseaseCode: false,
                isPlusImages: false,
                plusSomethingSelected: null,
                hasErrorPlusSomethingSelected: false,
                // dataCytoSpecLN :  { "dat_prepare": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "dat_ct": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "img": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "diag_code": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "status": { "id": "", "name": "" }, "assigned_to_user": { "id": "", "name": "" } },
                // IDLABSelected: null ,
                dataTest: {},


                reportEngine: 'legacy',
                isSelectImgForMakePdf : false,
                arrPropsToImgReport : []
            }
        },
        watch:{
            // isCytoShowing: function (val) {
                // if(val){
                //     this.dataTest = this.dataCytoSpecLN
                //     console.log(JSON.stringify(this.dataCytoSpecLN))
                // }

            // },
            plusSomethingSelected :{
                immediate : true,
                handler : function (val) {
                   if(val !== null){
                       this.hasErrorPlusSomethingSelected = false
                   }
                }
            },
            // dataCytoSpecLN : {
            //     immediate : true,
            //     handler : function (val) {
            //          console.log('watch')
            //          console.log(val)
            //
            //     }
            // }
        }

    }
</script>

<style scoped>
    div.container {
        padding: 10px 10px;
        margin: 10px 10px;
    }
    #button_edit {
        opacity: 1;
    }
    #button_edit:hover {
        opacity: 1;
    }

    .btn_plus {
        opacity: 1;
    }

    .btn_plus:hover {
        opacity: 1;
    }


</style>